import React from 'react'
import {Line} from 'react-chartjs-2'
import {Chart as ChartJS,
CategoryScale,
LinearScale,
PointElement,
LineElement,
Title,
Tooltip,
Legend,
} from "chart.js";

ChartJS.register(
    CategoryScale,
LinearScale,
PointElement,
LineElement,
Title,
Tooltip,
Legend, 
)
function Chart({arr=[],currency,days}) {
    const prices=[];
    // console.log(arr);
    const date=[];
    for (let i = 0; i < arr.length; i++) {
        if (days==='24h')date.push(new Date(arr[i][0]).toLocaleTimeString());
      else date.push(new Date(arr[i][0]).toLocaleDateString());
       prices.push(arr[i][1])
    }
// console.log(date);
 


  return (
   <>
   <Line options={{
    responsive:true,
   }}
   data={{
    labels:date,
    datasets:[{
        label:`price in ${currency}`,
        data:prices, borderColor:'rbg(255,99,132)',
        backgroundColor:'rbg(255,99,132,0.5)'
    }]
   }}
   />
   </>
  )
}

export default Chart